export const TOGGLE_OPTIONS = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

export const DEFAULT_TOGGLE_VALUE = false;
